<template>
  <v-container
    fluid
    class="pa-0"
    style="min-width: 1280px;"
  >
    <v-row
      no-gutters
      class="fill-height"
    >
      <!-- LEFT SIDEBAR -->
      <v-col
        cols="3"
        class="pa-3 d-flex flex-column"
      >
        <v-card
          class="pa-4 flex-grow-1 pt-6"

          rounded
          style="box-shadow: 4px 4px 24px 0px rgba(61, 104, 213, 0.16);"
        >
          <div
            class="d-flex flex-row justify-end pa-2 align-items-center text-size-14 my-1"
            style="color: var(--v-synthesis-ui-grey-01-base); border-radius: 8px;border: 1px solid var(--v-synthesis-ui-grey-02-base);"
          >
            <v-icon
              left
              size="16"
            >
              mdi-calendar
            </v-icon>
            {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.NumberOfDaysUnderCrisis') }}
          </div>

          <!-- Financial Instruments Accordion -->
          <v-row
            no-gutters
            class="mb-5"
          >
            <span
              class="text-size-12 font-weight-medium mt-6 d-flex align-center"
              style="color: var(--v-synthesis-ui-grey-01-base);"
            ><v-icon
              left
              size="16"
            >
              mdi-arrow-right
            </v-icon>{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.FinancialInstruments') }}</span>
          </v-row>
          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'availableCash'"
          />
          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'publicBrokeredDeposit'"
          />

          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'fhlbLine'"
          />

          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'interbankGroupLine'"
          />

          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'fedDiscountWindow'"
          />

          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'investments'"
          />

          <financial-instrument-label
            :amount="'$1,000'"
            :financial-instrument-key="'loanSale'"
          />

          <v-row
            no-gutters
            class="mb-3"
          >
            <span
              class="text-size-12 font-weight-medium mt-6 d-flex align-center"
              style="color: var(--v-synthesis-ui-grey-01-base);"
            >
              {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TotalAmountOfFunds') }}
            </span>
          </v-row>
          <div>
            <v-row
              no-gutters
              class="pa-2"
            >
              <v-col
                cols="12"
                no-gutters
                class="pa-2 mb-2 d-flex align-center justify-between"
                style="background-color: var(--v-synthesis-ui-green-08-base); border-radius: 8px; height: 48px;"
              >
                <synthesis-icon
                  name="deployed_funds"
                  class="mr-2"
                />
                <span
                  class="text-size-12 font-weight-medium "
                  style="color: var(--v-synthesis-ui-grey-01-base);"
                >
                  {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DeployedPerDay') }}
                </span>
              </v-col>
              <v-col
                cols="12"
                no-gutters
                class="pa-2 mb-2 d-flex align-center justify-between"
                style="background-color: var(--v-synthesis-ui-red-08-base); border-radius: 8px; height: 48px;"
              >
                <span
                  class="text-size-12 font-weight-medium d-flex align-center justify-between"
                  style="color: var(--v-synthesis-ui-grey-01-base);"
                >
                  <synthesis-icon
                    name="withdrawn_per_day"
                    class="mr-2"
                  />
                  {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.WithdrawnPerDay') }}
                </span>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>

      <!-- RIGHT PANEL -->
      <v-col
        cols="9"
        class="pa-3  d-flex "
      >
        <v-card
          class="pa-2 flex-grow-1"
          elevation="0"
          style="background-color: var(--v-synthesis-ui-grey-06-base);"
        >
          <!-- Crisis Days Row -->
          <v-col
            cols="12"
            class="mb-1"
          >
            <v-row
              no-gutters
              class="d-flex justify-space-around align-center "
              style=" border-radius: 12px; box-shadow: 8px 8px 24px 0px rgba(61, 104, 213, 0.24); height:48px; position:relative;
  "
            >
              <!-- Left caret -->
              <v-icon
                v-if="currentPage > 1"
                style="left: 5px; color: var(--v-synthesis-ui-blue-04-base); position: absolute;"
                @click="currentPage--"
              >
                mdi-chevron-left
              </v-icon>

              <!-- Right caret -->
              <v-icon
                v-if="currentPage < maxPage"
                style="right: 5px; color: var(--v-synthesis-ui-blue-04-base); position: absolute;"
                @click="currentPage++"
              >
                mdi-chevron-right
              </v-icon>
              <div
                v-for="day in getDays"
                :key="day"
                class="text-size-16 font-weight-medium"
                style="color: var(--v-synthesis-ui-blue-04-base);"
              >
                {{ day.toString().padStart(2, '0') }}
              </div>
            </v-row>
            <v-row
              no-gutters
              class="mb-3"
            >
              <span
                class="text-size-12 font-weight-medium mt-6 "
                style="color: var(--v-synthesis-ui-grey-01-base);"
              >{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DeploymentPerDay') }}</span>
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'availableCash'"
              />
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'publicBrokeredDeposit'"
              />
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'fhlbLine'"
              />
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'interbankGroupLine'"
              />
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'fedDiscountWindow'"
              />
            </v-row>
            <v-row

              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'investments'"
              />
            </v-row>
            <v-row
              class="mb-3"
            >
              <financial-instrument-graph
                :current-page="currentPage"
                :financial-instrument-key="'loanSale'"
              />
            </v-row>
          </v-col>

          <v-col
            class="mt-9"
            cols="12"
            style="
              background-color: rgba(255, 255, 255, 0.64);
              "
          >
            <v-row
              no-gutters
              class="mb-2 px-5 withdrawn-rows-container"
              style="height: 48px; background-color: var(--v-synthesis-ui-green-08-base); border-radius: 8px; gap:40px;flex-wrap: nowrap;"
            >
              <div
                v-for="(day, index) in deployedPerDay"
                :key="'pct-' + index"
                class="deployed-per-day-content text-center"
              >
                {{ formatDay(day) }}
              </div>
            </v-row>
            <v-row
              no-gutters
              class="mb-2 px-5 withdrawn-rows-container"
              style="height: 48px; background-color: var(--v-synthesis-ui-red-07-base); border-radius: 8px; gap:40px;flex-wrap: nowrap;"
            >
              <div
                v-for="(day, index) in withdrawnPerDay"
                :key="'pct-' + index"
                class="withdrawn-per-day-content text-center"
              >
                {{ formatDay(day) }}
              </div>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

    <script>
import { toNumberFormatNotationShort } from '@/lib/utils/helper'
import riskBaseCurrency from '@/theme/default/views/risks/mixins/riskBaseCurrency'
import FinancialInstrumentLabel from './FinancialInstrumentLabel.vue'
import FinancialInstrumentGraph from './FinancialInstrumentGraph.vue'
import { getDefenceReadinessPagination } from '../utils'
import SynthesisIcon from '@/theme/default/components/common/icons/SynthesisIcon.vue'

export default {
  name      : 'BankReadinessModularView',
  components: {
    FinancialInstrumentLabel,
    FinancialInstrumentGraph,
    SynthesisIcon
  },
  mixins: [riskBaseCurrency],
  props : {
    tableData: {
      type   : Object,
      default: () => {}
    }
  },
  dataStore: {
    BankReadiness       : 'RiskLiquidity.BankReadiness.Data',
    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'

  },
  data () {
    return {
      currentPage: 1
    }
  },
  computed: {
    id () {
      return this.user?.selectedAccountId || null
    },
    deployedPerDay () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).items
    },
    withdrawnPerDay () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.withdrawn)), this.currentPage).items
    },
    cumulativeWithdrawns () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.cumWithdrawn)), this.currentPage).items
    },
    getDays () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).days
    },
    maxPage () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return 1
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).totalPages
    }

  },
  created () {
    // Listen for crisis scenario changes to refresh data
    this.$bus.$on('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
  },
  beforeDestroy () {
    this.$bus.$off('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
  },

  mounted () {

  },
  methods: {
    onCrisisScenarioChanged (scenario) {
      this.currentPage = 1
    },
    formatDay (day) {
      return day ? this.riskBaseCurrencyDisplayName + day : '-'
    }
  }
}
    </script>

    <style scoped>

    .withdrawals-per-day-header {
      font-size: 12px;
      font-weight: 600;
      color: var(--v-synthesis-ui-grey-01-base);
    }

    .deployed-per-day-content {
      font-size: 14px;
      font-weight: 700;
      color: var(--v-synthesis-ui-green-00-base);
      letter-spacing: 0.2px;
    }

    .withdrawn-per-day-content {
      font-size: 14px;
      font-weight: 700;
      color: var(--v-synthesis-ui-red-00-base);
      letter-spacing: 0.2px;
    }

    .withdrawn-rows-container {
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      grid-template-rows: 1fr;
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      align-items: center;
}

    .cumulative-withdrawns {
      font-size: 14px;
      font-weight: 700;
      color: var(--v-synthesis-ui-red-00-base);
      letter-spacing: 0.2px;
    }

    ::v-deep .v-expansion-panel-content__wrap {
    padding-bottom: 0 !important;
  }
    </style>
